import { CellKeyFieldsPartial } from '../typings/common';

interface RetargetingChange {
    id: string;
    priceContext: number;
}

export const UPDATE_RETARGETING_COMMON_PRICE_CELL =
    'UPDATE_RETARGETING_COMMON_PRICE_CELL';
export type UPDATE_RETARGETING_COMMON_PRICE_CELL = typeof UPDATE_RETARGETING_COMMON_PRICE_CELL;

export interface UpdateRetargetingCommonPriceCell {
    type: UPDATE_RETARGETING_COMMON_PRICE_CELL;
    retargeting: RetargetingChange;
    cellKeyPartial: CellKeyFieldsPartial;
}

export const updateRetargetingCommonPriceCell = (
    retargeting: RetargetingChange,
    columnName: string
): UpdateRetargetingCommonPriceCell => {
    return {
        type: UPDATE_RETARGETING_COMMON_PRICE_CELL,
        retargeting,
        cellKeyPartial: {
            id: retargeting.id,
            column: columnName
        }
    };
};

export const UPDATE_RETARGETING = 'UPDATE_RETARGETING';
export type UPDATE_RETARGETING = typeof UPDATE_RETARGETING;

export interface UpdateRetargeting {
    type: UPDATE_RETARGETING;
    retargeting: RetargetingChange;
}

export function updateRetargeting(
    retargeting: RetargetingChange
): UpdateRetargeting {
    return {
        type: UPDATE_RETARGETING,
        retargeting
    };
}

export const SAVE_RETARGETINGS_MASS_COMMON_PRICE_EDITOR =
    'SAVE_RETARGETINGS_MASS_COMMON_PRICE_EDITOR';
export type SAVE_RETARGETINGS_MASS_COMMON_PRICE_EDITOR = typeof SAVE_RETARGETINGS_MASS_COMMON_PRICE_EDITOR;

export interface SaveRetargetingsMassCommonPriceEditor {
    type: SAVE_RETARGETINGS_MASS_COMMON_PRICE_EDITOR;
}

export const saveRetargetingsMassCommonPriceEditor = (): SaveRetargetingsMassCommonPriceEditor => {
    return {
        type: SAVE_RETARGETINGS_MASS_COMMON_PRICE_EDITOR
    };
};

export type RetargetingCommonPriceEditorAction =
    | SaveRetargetingsMassCommonPriceEditor
    | UpdateRetargetingCommonPriceCell
    | UpdateRetargeting;
